import { UserTheme } from "../app/services/external/config/misc";


export enum Theme {
  light = UserTheme.Light,
  dark = UserTheme.Dark
}
